import './style.css';
import { createGlobe } from './game/globeSetup.js';
import { GlobeQuiz } from './game/GlobeQuiz.js';
import { setOptions, getOptions } from './runtime.js';
import { QuizPanel } from './ui/quizPanel.js';
import { StartMenu } from './ui/startMenu.js';
import { StatsPanel } from './ui/statsPanel.js';
import { sounds } from './ui/sounds.js';

async function bootstrap(): Promise<void> {
  const globeEl = document.getElementById('globe');
  const uiEl = document.getElementById('ui');
  const menuEl = document.getElementById('menu');
  const statsEl = document.getElementById('stats');
  if (!globeEl || !uiEl || !menuEl || !statsEl) {
    throw new Error('#globe / #ui / #menu / #stats 요소를 찾을 수 없습니다');
  }

  const view = await createGlobe(globeEl);
  const panel = new QuizPanel(uiEl);
  const menu = new StartMenu(menuEl, view.countries);
  const stats = new StatsPanel(statsEl);

  const quiz = new GlobeQuiz(view, {
    onStateChange: (state) => panel.renderState(state),
    onAsk: (q, info) => {
      panel.renderQuestion(q, quiz.getState().currentMode, info.modeChanged);
    },
    onResult: (correct, picked, answer) => {
      panel.renderResult(correct, picked, answer);
      if (correct) {
        const combo = quiz.getState().combo;
        if (combo >= 3) sounds.combo(combo);
        else sounds.correct();
      } else {
        sounds.wrong();
      }
    },
    onFinish: (state) => {
      panel.renderFinish(state);
      sounds.finish();
    },
    onTimerTick: (remaining) => panel.renderTimer(remaining),
    onMisclick: () => {
      panel.shakePrompt();
      sounds.tick(440);
    },
    onCountdown: (sec) => sounds.countdown(sec),
  });

  view.setPolygonClick((iso2) => quiz.submitByIso2(iso2));

  const startGame = (): void => {
    panel.hideFinish();
    panel.resetCombo();
    panel.applyOptionsForRound();
    quiz.start();
  };

  panel.setHandlers({
    onPick: (country) => quiz.submit(country),
    onRestart: () => startGame(),
    onMenu: () => {
      panel.hideFinish();
      menu.show();
    },
    onOpenStats: () => stats.show(),
    onSkipDelay: () => quiz.skipDelay(),
  });

  menu.setHandlers({
    onStart: () => startGame(),
    onOpenStats: () => stats.show(),
  });

  stats.setHandlers({
    onClose: () => {
      // 직전 화면이 그대로 살아 있으므로 별도 동작 없음.
    },
    onStartReview: () => {
      stats.hide();
      menu.hide();
      panel.hideFinish();
      setOptions({ ...getOptions(), pool: 'review' });
      startGame();
    },
  });

  menu.show();
}

bootstrap().catch((err) => {
  console.error(err);
  const body = document.body;
  body.innerHTML = `
    <div style="padding:24px;color:#fff;background:#900;font-family:sans-serif">
      <h2>로드 실패</h2>
      <pre>${(err as Error).message}</pre>
    </div>
  `;
});
